import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';

interface ActionButtonsProps {
  onEdit?: () => void;
  onDelete?: () => void;
  onView?: () => void;
  showEdit?: boolean;
  showDelete?: boolean;
  showView?: boolean;
  editTooltip?: string;
  deleteTooltip?: string;
  viewTooltip?: string;
  size?: 'small' | 'medium' | 'large';
  editDisabled?: boolean;
  deleteDisabled?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onEdit,
  onDelete,
  onView,
  showEdit = true,
  showDelete = true,
  showView = false,
  editTooltip = 'Edit',
  deleteTooltip = 'Delete',
  viewTooltip = 'View',
  size = 'small',
  editDisabled = false,
  deleteDisabled = false
}) => {
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
      {showView && onView && (
        <Tooltip title={viewTooltip}>
          <IconButton
            size={size}
            onClick={onView}
            sx={{ color: 'primary.main' }}
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
      
      {showEdit && onEdit && (
        <Tooltip title={editTooltip}>
          <span>
            <IconButton
              size={size}
              onClick={onEdit}
              disabled={editDisabled}
              sx={{
                color: editDisabled ? 'text.disabled' : 'primary.main',
                '&.Mui-disabled': {
                  opacity: 0.6
                }
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      
      {showDelete && onDelete && (
        <Tooltip title={deleteTooltip}>
          <span>
            <IconButton
              size={size}
              onClick={onDelete}
              disabled={deleteDisabled}
              sx={{
                color: deleteDisabled ? 'text.disabled' : 'error.main',
                '&.Mui-disabled': {
                  opacity: 0.6
                }
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default ActionButtons; 